/* Export logic */

const getSum = (arr) => {
	if (!arr || !Array.isArray(arr)) {
		return 0;
	}
	return arr.reduce((sum, current) => sum + (current || 0), 0);
};

function formatMetricValue(key, value, isCsv = false) {
	if (value === null || value === undefined) return "N/A";

	const upperKey = String(key).toUpperCase();
	const graphData = window.WingmanState?.swanbot_dataexplorer_graphdata || {};
	const axisTypes = graphData.axis_types || {};
	const transactionTypes = Array.isArray(axisTypes.transactions) ? axisTypes.transactions : [];
	const currencyTypes = [
		...(Array.isArray(axisTypes.cpm) ? axisTypes.cpm : []),
		...(Array.isArray(axisTypes.revenue) ? axisTypes.revenue : [])
	];

	if (transactionTypes.some(item => upperKey === String(item).toUpperCase())) {
		const formattedNum = Math.floor(value).toLocaleString();
		return isCsv ? formattedNum.replaceAll(',', '') : formattedNum;
	}

	if (currencyTypes.some(item => upperKey === String(item).toUpperCase())) {
		const formatted = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',
			minimumFractionDigits: 2
		}).format(value);
		return isCsv ? formatted.replaceAll(',', '') : formatted;
	}

	if (upperKey.includes("RATE") || upperKey.includes("PERCENT")) {
		return Number(value).toFixed(2);
	}

	const formattedNum = Number(value).toLocaleString();
	return isCsv ? formattedNum.replaceAll(',', '') : formattedNum;
}

function prepareAllDataRows(dataObject) {
	const parseGraphPayload = function (value) {
		if (typeof value === 'string') {
			try {
				return JSON.parse(value);
			} catch (e) {
				return null;
			}
		}

		return value && typeof value === 'object' ? value : null;
	};

	const rows = [];
	const mainGraphData = parseGraphPayload(dataObject.graphs);
	const compareGraphData = parseGraphPayload(dataObject.graphs_compare);

	const mainTotals = mainGraphData?.totals || {};
	rows.push({ name: "[Source Totals]", totals: mainTotals, isComparison: false });

	if (compareGraphData?.totals) {
		rows.push({
			name: "[Source Totals] Comparison",
			totals: compareGraphData.totals,
			isComparison: true
		});
	}

	if (Array.isArray(dataObject.subgraphGroupData)) {
		dataObject.subgraphGroupData.forEach((group, index) => {
			const groupObj = parseGraphPayload(group);
			const title = dataObject.subgraphGroupTitles?.[index] || `[No Name Source ${index + 1}]`;

			rows.push({ name: title, totals: groupObj?.totals || {}, isComparison: false });

			if (dataObject.subgraphs_compare && dataObject.subgraphs_compare[index]) {
				const comp = dataObject.subgraphs_compare[index];
				const compObj = parseGraphPayload(comp);
				rows.push({
					name: `${title} Comparison`,
					totals: compObj?.totals || {},
					isComparison: true
				});
			}
		});
	}

	return rows;
}

function resolveDataExplorerGraphId() {
	if (window.WingmanState?.swanbot_dataexplorer_graph_id) {
		return window.WingmanState.swanbot_dataexplorer_graph_id;
	}

	if (typeof globalThis.swanbot_dataexplorer_graph_id === 'string' && globalThis.swanbot_dataexplorer_graph_id) {
		return globalThis.swanbot_dataexplorer_graph_id;
	}

	const graphContainer = document.getElementById('graph-dataexplorer-details');
	const graphElement = graphContainer?.querySelector('.js-plotly-plot[id], [id^="swanbot_graph_"]');
	const graphId = graphElement?.id || '';

	if (graphId && window.WingmanState?.swanbot_dataexplorer_graph_id !== graphId) {
		window.WingmanState.swanbot_dataexplorer_graph_id = graphId;
	}

	if (graphId) {
		return graphId;
	}

	return '';
}

function hasEntries(value) {
	if (!value || typeof value !== 'object') {
		return false;
	}

	return Object.keys(value).length !== 0;
}

export function download_dataexplorer_div(evt) {



	const graphId = resolveDataExplorerGraphId();
	const dataElement = document.getElementById(graphId);
	const graph_date_selected = document.getElementById("dataexplorer_date-selected-jsfe");

	let daterange = '';
	let daterange_chart = '';
	let dimensions_chart = window.WingmanState.swanbot_dataexplorer_graphdata["subgraphGroupDimensions"];
	let chart_filters = window.WingmanState.swanbot_dataexplorer_graphdata["filters"];
	let chart_filters_str = '';
	let chart_title = '';
	let dimensions_values = [];
	let dimensions_values_str = '';

	if (graph_date_selected) {
		daterange = graph_date_selected.innerHTML;
		daterange_chart = graph_date_selected.innerHTML;
		daterange = daterange.replaceAll(' ', '_').replaceAll(':', '');
	} else {
		console.warn("Element with ID 'dataexplorer_date-selected' not found.");
	}

	let file_title = 'Total_Transactions_' + daterange;

	if (hasEntries(chart_filters)) {


		let formattedFilterStrings = [];

		for (const key in chart_filters) {
			if (Object.hasOwnProperty.call(chart_filters, key)) {
				const title = key;
				const values = chart_filters[key];
				const valuesString = values.join(', '); // Join the array values into a string
				formattedFilterStrings.push(`${title}: ${valuesString}`); // Add to our array of formatted strings
				dimensions_values.push(key)
			}
		}

		// Join all the individual formatted strings with a separator (e.g., newline or semicolon)
		const finalFormattedFiltersString = formattedFilterStrings.join(', ');

		dimensions_values_str = dimensions_values.join(', ');

		chart_filters_str = finalFormattedFiltersString; //'Filters: ' + 
	}





	if (dimensions_values_str) {
		chart_title = 'Total Transactions (by ' + dimensions_values_str + ')\n';
	} else {
		chart_title = 'Total Transactions\n';
	}

	chart_title = chart_title + daterange_chart;



	if (!dataElement || !dataElement.data) {
		console.error(`Error: Data explorer graph element '${graphId || 'unknown'}' not found or does not contain 'data'.`);
		return false;
	}

	const data = dataElement.data;

	if (!data || !data[0] || !data[0].x) { // Only check for data[0] and x, as y will be checked per series
		console.error("Error: 'data' is not in the expected format (missing data[0] or x).");
		return false;
	}

	const val_dates = [];
	data[0].x.forEach((xVal) => {
		val_dates.push(xVal);
	});

	let jsondata = {
		"Date": val_dates,
		"Title": chart_title,
		"Dimensions": dimensions_chart,
		"Filters": chart_filters_str,
		"values": {} // Initialize values as an empty object
	};

	// Iterate through all data series
	data.forEach((series, index) => {
		if (series && series.name && series.y) {
			jsondata["values"][series.name] = series.y;
		} else {
			console.warn(`Skipping malformed series at index ${index}: missing name or y data.`);
		}
	});

	//console.log("data to post", jsondata);

	axios.post(
		'/xapi/pptx',
		jsondata, {
		responseType: 'blob',
		headers: {
			'Content-Type': 'application/json'
		}
	}
	).then(response => {
		const href = URL.createObjectURL(response.data);
		const link = document.createElement('a');
		link.href = href;
		link.setAttribute('download', file_title + '.pptx');
		link.style.visibility = 'hidden';
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
		URL.revokeObjectURL(href); // Clean up the object URL
	})
		.catch(error => {
			console.error("POST error:", error);
		});

	return true;




	// if ($(".canvas-body").length > 0) {
	// 	$(".canvas-body").empty();
	// }

	// document.getElementById("downloadMenuButton").classList.add("btn-hide");
	// document.getElementById("download_drowpdown_container").classList.add("btn-hide");



	// let btn_tgz = document.getElementById("dataexplorer_toggle_subgroup");
	// if (btn_tgz) {
	// 	  btn_tgz.classList.add("btn-hide");
	// }
	// const sgbs = document.getElementsByClassName('show_subgrouping_button');
	// for (let i = 0; i < sgbs.length; i++) {
	//     sgbs[i].classList.add('btn-hide');
	// }


	// html2canvas(document.getElementById("dataexplorer-data-layout"), {
	// 	  width: document.getElementById('dataexplorer-data-layout').offsetWidth,
	//     height: document.getElementById('dataexplorer-data-layout').offsetHeight,
	// 	  scale: 1,
	//     useCORS: true, 
	//     allowTaint: false
	//   })
	//   .then(function(c) {

	//   	var owidth = document.getElementById('dataexplorer-data-layout').offsetWidth;
	//     	var oheight = document.getElementById('dataexplorer-data-layout').offsetHeight;
	// 		var customerid = document.querySelector("#customer_id").value;
	// 		  const widthInPx = c.width; // or use getBoundingClientRect()
	// 		  const heightInPx = c.height; 

	// 		  // Convert pixels to millimeters
	// 		  const widthInMm = widthInPx * 0.26; 
	// 		  const heightInMm = heightInPx * 0.26;


	// 		var end_date = get_end_date.format('YYYY_M_D');


	//   	var imgData = c.toDataURL('image/png');              
	//       var doc = new jspdf.jsPDF({
	//       	orientation: "p", 
	// 		    unit: "mm"
	//       });

	// 		var width = doc.internal.pageSize.getWidth();
	// 		var height = doc.internal.pageSize.getHeight();
	// 		var widthRatio = width / c.width;
	// 		var heightRatio = height / c.height;
	// 		var ratio = Math.min(widthRatio, heightRatio); // Maintain aspect ratio




	//       //doc.addImage(imgData, 'PNG', 10, 10, widthInMm+60, heightInMm+60);
	// 		doc.addImage(imgData, 'PNG', 0, 0, c.width * ratio, c.height * ratio);
	//       doc.save(customerid+'_'+end_date+'_data_explorer.pdf');

	//       /*

	// 		document.getElementsByClassName("canvas-body")[0].appendChild(c);


	// 		const canvas = document.querySelector(".canvas-body canvas")
	// 		const canvasImg = canvas.toDataURL();

	// 		var elem = document.createElement("img");

	// 		document.getElementsByClassName("canvas-body")[0].appendChild(elem);
	// 		const cimg = document.querySelector(".canvas-body img")
	// 		canvas.remove();

	// 		cimg.setAttribute("src", canvasImg)
	// 		*/

	// 		//console.log("done saving image to cimg")

	// 		document.getElementById("downloadMenuButton").classList.remove("btn-hide");
	// 		document.getElementById("download_drowpdown_container").classList.remove("btn-hide");

	// 		let btn_tgz = document.getElementById("dataexplorer_toggle_subgroup");
	// 		if (btn_tgz) {
	// 			  btn_tgz.classList.remove("btn-hide");
	// 		}
	// 		const sgbs = document.getElementsByClassName('show_subgrouping_button');
	// 		for (let i = 0; i < sgbs.length; i++) {
	// 		    sgbs[i].classList.remove('btn-hide');
	// 		}
	//   });



}

export function download_dataexplorer_from_datasource_csv() {
	let globalGraphData = window.WingmanState.swanbot_dataexplorer_graphdata["graphs"];
	let compareGraphData = window.WingmanState.swanbot_dataexplorer_graphdata["graphs_compare"];
	let subGraphData = window.WingmanState.swanbot_dataexplorer_graphdata["subgraphGroupData"];
	let subGraphCompareData = window.WingmanState.swanbot_dataexplorer_graphdata["subgraphs_compare"];
	let subTitles = window.WingmanState.swanbot_dataexplorer_graphdata["subgraphGroupTitles"] || [];

	if (typeof globalGraphData === 'string') {
		try { globalGraphData = JSON.parse(globalGraphData); } catch (e) { }
	}
	if (typeof compareGraphData === 'string' && compareGraphData !== "") {
		try { compareGraphData = JSON.parse(compareGraphData); } catch (e) { }
	}

	if (!globalGraphData) {
		console.error("No global graph data found.");
		window.display_toast("No data found to download. Try Again!", mdtoast.ERROR);
		return;
	}

	let dataExplorerDailyOnlyInput = document.getElementById("dataexplorer_daily_only");
	let isDaily = window.swanbot_dataexplorer_filter_period === "day" || (dataExplorerDailyOnlyInput && String(dataExplorerDailyOnlyInput.value).toLowerCase() === "true");
	let dataKey = isDaily ? "daily_totals" : "graphs";

	function getFirstSeriesLength(obj) {
		if (!obj || !obj[dataKey]) return 0;
		let traceNames = Object.keys(obj[dataKey]);
		if (traceNames.length === 0) return 0;
		let firstSeries = obj[dataKey][traceNames[0]];
		return Array.isArray(firstSeries) ? firstSeries.length : 0;
	}

	function normalizeDailyDateValue(value) {
		if (value instanceof Date && !Number.isNaN(value.getTime())) {
			return value.toISOString().slice(0, 10);
		}

		let textValue = String(value || '').trim();
		if (!textValue) return '';

		return textValue.split(/[ T]/)[0];
	}

	function resolveDailyDates(obj) {
		let expectedLength = getFirstSeriesLength(obj);
		let normalizedDays = Array.isArray(obj?.days)
			? obj.days.map(normalizeDailyDateValue).filter(Boolean)
			: [];

		if (expectedLength > 0 && normalizedDays.length === expectedLength && new Set(normalizedDays).size === expectedLength) {
			return normalizedDays;
		}

		if (Array.isArray(obj?.hours) && obj.hours.length > 0) {
			let uniqueDates = [];
			let seenDates = new Set();

			for (let hourValue of obj.hours) {
				let normalizedDate = normalizeDailyDateValue(hourValue);
				if (!normalizedDate || seenDates.has(normalizedDate)) continue;
				seenDates.add(normalizedDate);
				uniqueDates.push(normalizedDate);

				if (expectedLength > 0 && uniqueDates.length >= expectedLength) {
					break;
				}
			}

			if (uniqueDates.length > 0) {
				return expectedLength > 0 ? uniqueDates.slice(0, expectedLength) : uniqueDates;
			}
		}

		return normalizedDays;
	}

	let dates = isDaily ? resolveDailyDates(globalGraphData) : globalGraphData.hours;

	if (!dates || dates.length === 0) {
		window.display_toast("No dates found to download.", mdtoast.ERROR);
		return;
	}

	let header = ['Date'];
	let rows = dates.map(d => [d]);

	function addColumns(prefix, obj) {
		if (!obj || !obj[dataKey]) return;
		let traceData = obj[dataKey];
		let traceNames = Object.keys(traceData);
		for (let name of traceNames) {
			header.push(`"${prefix}${name}"`);
			let values = traceData[name];
			let compareDates = isDaily ? obj.days : obj.hours;

			// Map values if compare dates has a different lengths (rare but possible in compares)
			// Generally we expect them to align. If not, this simple map might offset.
			// Currently assuming they map 1:1 with dates.
			for (let i = 0; i < dates.length; i++) {
				rows[i].push(values[i] !== undefined ? values[i] : '');
			}
		}
	}

	// Add main traces
	addColumns('Total: ', globalGraphData);

	// Add main compare traces
	if (compareGraphData && compareGraphData[dataKey]) {
		addColumns('Compare Total: ', compareGraphData);
	}

	// Add subgraphs
	if (subGraphData && subGraphData.length > 0) {
		for (let i = 0; i < subGraphData.length; i++) {
			let subtitle = subTitles[i] || `Subgroup ${i}`;
			addColumns(`${subtitle} - `, subGraphData[i]);

			if (subGraphCompareData && subGraphCompareData[i]) {
				addColumns(`Compare ${subtitle} - `, subGraphCompareData[i]);
			}
		}
	}

	let csvContent = header.join(',') + '\n';
	rows.forEach(row => {
		csvContent += row.join(',') + '\n';
	});

	const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
	const graphDateSelected = document.getElementById("dataexplorer_date-selected-jsfe");
	let daterange = graphDateSelected ? graphDateSelected.textContent : '';
	daterange = daterange.replaceAll(' ', '_').replaceAll(':', '');

	const link = document.createElement("a");
	if (link.download !== undefined) {
		const url = URL.createObjectURL(blob);
		link.setAttribute("href", url);
		link.setAttribute("download", "Wingman_Data_Explorer_Full_Export_" + daterange + ".csv");
		link.style.visibility = 'hidden';
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	}

	window.display_toast("Full CSV file downloaded.", mdtoast.INFO);
}

export function download_dataexplorer_csv() {
	const graphId = resolveDataExplorerGraphId();
	const graphElement = document.getElementById(graphId);
	const data = graphElement?.data;

	if (!data || data.length === 0 || !data[0].x || data[0].x.length === 0) {
		console.error("No data found to download.");
		window.display_toast("No data found to download. Try Again!", mdtoast.ERROR);
		return;
	}

	// Generate the CSV header row dynamically from trace names.
	let header = 'Date';
	data.forEach(trace => {
		header += `,${trace.name || 'Unnamed Trace'}`;
	});
	let csvContent = `${header}\n`;

	// Loop through each data point to create the CSV rows.
	data[0].x.forEach((xVal, index) => {
		let row = `${xVal}`;
		data.forEach(trace => {
			const yVal = trace.y[index] !== undefined ? trace.y[index] : '';
			row += `,${yVal}`;
		});
		csvContent += `${row}\n`;
	});

	// Create a Blob from the CSV content for downloading.
	const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

	// Get the date range for the filename.
	const graphDateSelected = document.getElementById("dataexplorer_date-selected-jsfe");
	let daterange = graphDateSelected ? graphDateSelected.textContent : '';
	daterange = daterange.replaceAll(' ', '_').replaceAll(':', '');

	// Create and trigger a download link.
	const link = document.createElement("a");
	if (link.download !== undefined) {
		const url = URL.createObjectURL(blob);
		link.setAttribute("href", url);
		link.setAttribute("download", "Wingman_Data_Explorer_Export_Overview_Plot_" + daterange + ".csv");
		link.style.visibility = 'hidden';
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	}

	window.display_toast("CSV file downloaded.", mdtoast.INFO);
}

export function downloadCSV_classic(dataObject) {
	const columns = [...dataObject.maingraphTitles];
	//columns.shift();
	const header = ["Source", ...columns.map(title => (title === "total") ? "Total Transactions" : title)].join(',');

	const mainGraphs = JSON.parse(dataObject.graphs).data;
	const allDataRows = [{ data: mainGraphs, name: "[Source Totals]" }];
	dataObject.subgraphGroupData.forEach((group, index) => {
		let subgroupTitle = dataObject.subgraphGroupTitles[index];
		allDataRows.push({
			data: JSON.parse(group).data,
			name: subgroupTitle || `[No Name]`
		}); //Source (${index + 1})`
	});

	const rows = allDataRows.map(row => {
		const values = [row.name];
		columns.forEach(title => {
			const graph = row.data.find(g => g.name === (title === "Total Transactions" ? "total" : title));
			let formattedValue = "N/A";
			if (graph && graph.y) {
				const total = getSum(graph.y);
				if (typeof graph.yaxis === 'undefined' || graph.yaxis === 'y' || graph.yaxis === 'y2') {
					formattedValue = new Intl.NumberFormat('en-US', {
						style: 'currency',
						currency: 'USD',
						minimumFractionDigits: 2
					}).format(total);
				} else {
					formattedValue = total.toLocaleString();
				}
			}
			// Remove commas for CSV formatting to prevent issues
			values.push(String(formattedValue).replaceAll(',', ''));
		});
		return values.join(',');
	});

	const csvContent = `${header}\n${rows.join('\n')}`;
	const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
	const link = document.createElement('a');

	// Get date range and format the filename
	const graphDateSelected = document.getElementById("dataexplorer_date-selected-jsfe");
	let daterange = graphDateSelected ? graphDateSelected.textContent : '';
	daterange = daterange.replaceAll(' ', '_').replaceAll(':', '');
	const fileName = `Wingman_Data_Explorer_Export_${daterange}.csv`;

	if (link.download !== undefined) {
		const url = URL.createObjectURL(blob);
		link.setAttribute('href', url);
		link.setAttribute('download', fileName);
		link.style.visibility = 'hidden';
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
		URL.revokeObjectURL(url);
	} else {
		console.error("Browser does not support download attribute.");
	}
}

export function createSummaryTable_classic(dataObject, containerId) {
	const tableContainer = document.getElementById(containerId);
	if (!tableContainer) {
		console.error("Table container not found:", containerId);
		return;
	}
	tableContainer.innerHTML = '';

	const table = document.createElement('table');
	table.className = "table table-striped table-hover rounded-3 overflow-hidden border border-2";
	table.id = "sourceSummaryTable"; // Set the ID as requested

	const thead = document.createElement('thead');
	thead.className = "thead-light bg-light";
	const headerRow = document.createElement('tr');

	// Add column for the row title (Source, etc.)
	const nameHeader = document.createElement('th');
	nameHeader.className = "text-start py-1 px-2";
	nameHeader.textContent = "Source";
	headerRow.appendChild(nameHeader);

	// Add columns from maingraphTitles
	const columns = dataObject.maingraphTitles;
	//columns.shift(); // remove first "all" column
	columns.forEach(title => {
		const th = document.createElement('th');
		th.className = "text-start py-1 px-2";
		th.textContent = (title === "total") ? "Total Transactions" : title;
		headerRow.appendChild(th);
	});

	thead.appendChild(headerRow);
	table.appendChild(thead);

	const tbody = document.createElement('tbody');

	// Parse the JSON strings inside the data object
	const mainGraphs = JSON.parse(dataObject.graphs).data;
	const subgraphData = dataObject.subgraphGroupData.map(group => JSON.parse(group));
	const allDataRows = [{ data: mainGraphs, name: "[Source Totals]" }];



	dataObject.subgraphGroupData.forEach((group, index) => {
		let subgroupTitle = dataObject.subgraphGroupTitles[index];
		allDataRows.push({
			data: JSON.parse(group).data,
			name: subgroupTitle || `[No Name]`
		});
	});


	// Source (${index + 1}

	allDataRows.forEach((row, rowIndex) => {
		const tr = document.createElement('tr');

		const nameCell = document.createElement('td');
		nameCell.className = "py-1 px-2";
		nameCell.textContent = row.name;
		tr.appendChild(nameCell);

		columns.forEach(title => {
			const cell = document.createElement('td');
			cell.className = "py-1 px-2";

			const graph = row.data.find(g => g.name === (title === "Total Transactions" ? "total" : title));
			let formattedValue = "N/A";
			if (graph && graph.y) {
				const total = getSum(graph.y);
				if (typeof graph.yaxis === 'undefined' || graph.yaxis === 'y' || graph.yaxis === 'y2') {
					formattedValue = new Intl.NumberFormat('en-US', {
						style: 'currency',
						currency: 'USD',
						minimumFractionDigits: 2
					}).format(total);
				} else {
					formattedValue = total.toLocaleString();
				}
			}
			cell.textContent = formattedValue;
			tr.appendChild(cell);
		});
		tbody.appendChild(tr);
	});

	table.appendChild(tbody);
	tableContainer.appendChild(table);
}

export function downloadCSV(dataObject) {
	const allRows = prepareAllDataRows(dataObject);
	if (allRows.length === 0) {
		console.error("No data found for CSV generation");
		return;
	}

	// Identify Unique Columns
	const metricKeysSet = new Set();
	allRows.forEach(row => {
		if (row.totals) {
			Object.keys(row.totals).forEach(key => metricKeysSet.add(key));
		}
	});
	const metricKeys = Array.from(metricKeysSet);

	/**
	 * Helper to escape CSV fields. 
	 * Wraps in quotes if field contains commas, quotes, or newlines.
	 * Replaces internal double quotes with two double quotes (standard CSV escaping).
	 */
	const escapeCsv = (val) => {
		if (val === null || val === undefined) return "";
		let str = String(val);
		if (str.includes(',') || str.includes('"') || str.includes('\n') || str.includes('\r')) {
			str = '"' + str.replace(/"/g, '""') + '"';
		}
		return str;
	};

	// Create CSV Lines
	const csvLines = [];

	// Header Line
	const header = [
		escapeCsv("Source"),
		...metricKeys.map(k => escapeCsv(k.replace(/_/g, ' ').toUpperCase()))
	];
	csvLines.push(header.join(','));

	// Data Lines
	allRows.forEach(row => {
		const line = [escapeCsv(row.name)];
		metricKeys.forEach(key => {
			const val = row.totals ? row.totals[key] : undefined;
			const formatted = val !== undefined ? formatMetricValue(key, val, true) : "";
			line.push(escapeCsv(formatted));
		});
		csvLines.push(line.join(','));
	});

	const csvContent = csvLines.join('\n');
	const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
	const link = document.createElement('a');

	const graphDateSelected = document.getElementById("dataexplorer_date-selected-jsfe");
	let daterange = graphDateSelected ? graphDateSelected.textContent : 'Export';
	daterange = daterange.trim().replaceAll(' ', '_').replaceAll(':', '').replaceAll('/', '-');

	const fileName = `Wingman_Data_Explorer_Export_${daterange}.csv`;

	if (link.download !== undefined) {
		const url = URL.createObjectURL(blob);
		link.setAttribute('href', url);
		link.setAttribute('download', fileName);
		link.style.visibility = 'hidden';
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
		URL.revokeObjectURL(url);
	} else {
		console.error("Browser does not support download attribute.");
	}
}

